
<div class="ttmodal" id="schematicmasterWindow">
  <div id="schematicWindowHeader_" class="ttmodal__header">
    <span class="ttmodal__title">Schematic and Observation Point - Add Observation Point</span>
    <span style="display: none;" class="ttmodal__title">
      <mat-checkbox color="primary" [(ngModel)]="showFixedCracks" (change)="onToggleFixedCracks()"></mat-checkbox>
      Show Fixed Cracks
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>

  <div class="tt-body">
    <div class="div-left-pan">
      <div class="obs-type">
        <span class="left-span">Types</span>
        <mat-radio-group name="type" [(ngModel)]="TypeID" class="horizontal-group" style="display: flex; flex-wrap: wrap; gap: 15px;">
          <mat-radio-button *ngIf="_showCrackTypeOption"
                            [value]="2"
                            title="Crack Measurement"
                            #crack
                            (change)="changeType($event)"
                            [disabled]="disabledCrackOption"
                            style="flex: 1 0 calc(33% - 8px);">
            Crack
          </mat-radio-button>

          <mat-radio-button *ngIf="_showOtherTypeOption && enableNormal"
                            [value]="1"
                            title="Thickness Measurement"
                            #normal
                            (change)="changeType($event)"
                            style="flex: 1 0 calc(33% - 8px);">
            Single Obs. Point
          </mat-radio-button>

          <mat-radio-button *ngIf="_showOtherTypeOption && enableEvaluation"
                            [value]="3"
                            title="Evaluation"
                            #eval
                            (change)="changeType($event)"
                            style="flex: 1 0 calc(33% - 8px);">
            Evaluation
          </mat-radio-button>

          <mat-radio-button *ngIf="_showOtherTypeOption && enableSelection"
                            [value]="4"
                            title="Selection"
                            #selection
                            (change)="changeType($event)"
                            style="flex: 1 0 calc(33% - 8px);">
            Selection
          </mat-radio-button>

          <mat-radio-button *ngIf="_showOtherTypeOption && enablePassFail"
                            [value]="5"
                            title="Pass/Fail"
                            #passfail
                            (change)="changeType($event)"
                            style="flex: 1 0 calc(33% - 8px);">
            Pass/Fail
          </mat-radio-button>

          <mat-radio-button *ngIf="_showOtherTypeOption && enableYesNo"
                            [value]="6"
                            title="Yes/No"
                            #yesno
                            (change)="changeType($event)"
                            style="flex: 1 0 calc(33% - 8px);">
            Yes/No
          </mat-radio-button>

        </mat-radio-group>
      </div>

      <div *ngIf="isDFI!=true" class="flex-row">
        <span class="left-span">Component</span>
        <mat-form-field style=" width: 100%;">
          <mat-select (selectionChange)="onchangeComponent($event)" placeholder="Select Component" [(ngModel)]="componentId" ngDefaultControl required>
            <mat-option value="" disabled selected>Select Component</mat-option>
            <mat-option *ngFor="let component of componentList" [value]="component.Id">{{component.Name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="isDFI==true" class="flex-row">
        <span class="left-span">Component</span>
        <mat-form-field style=" width: 100%;">
          <mat-select (selectionChange)="onchangeComponent($event)" placeholder="Select Component" [(ngModel)]="componentId" ngDefaultControl required>
            <mat-option value="" disabled selected>Select Component</mat-option>
            <mat-option *ngFor="let component of componentList" [value]="component.ComponentId">{{component.ComponentName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex-row">
        <span class="left-span">Name</span>
        <mat-form-field style=" width: 100%;">
          <input matInput placeholder="Observation Name" type="text"
                 [(ngModel)]="Compname" ngDefaultControl required>
        </mat-form-field>
      </div>
      <div style="display: flex; flex-direction: row; margin-top: 2%;margin-bottom: 2%;" *ngIf="!IsGETInspection">
        <span class="left-span">Date</span>
        <mat-form-field class="header-form-full-width" style="">

          <input matInput [matDatepicker]="endDatePicker" placeholder="Created Date" [(ngModel)]="eventDate" [min]="minDate" [max]="maxDate">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="flex-row" *ngIf="TypeID==2">
        <span style="align-self: center; min-width: 120px; width: 319px;"><b>Start Point</b> <i title="Click pencil, then click specific point in image to create crack start point.">(Click to start point on the image)</i></span>
        <mat-form-field style="width: 42%;">
          <input matInput type="text" [(ngModel)]="startXY" #start_="ngModel" [disabled]="true">
        </mat-form-field>
        <a (click)="ClearCurrentStartXY()" [ngClass]="isStartEdit ? 'selected-edit-point' : 'edit-point'"><i class="material-icons square-button__icon" style="cursor: pointer;" title="Click to start point">edit</i></a>
        <!--<a *ngIf="isStartEdit==false"><i class="material-icons square-button__icon" title="Confirm Starting Point" style="cursor: pointer;">check_box</i></a>
        <a (click)="ConfirmStartXY()" *ngIf="isStartEdit==true"><i class="material-icons square-button__icon" title="Confirm Starting Point" style="cursor: pointer;">check_box_outline_blank</i></a>-->
      </div>

      <div class="flex-row" *ngIf="TypeID==2">
        <span style="align-self: center; min-width: 120px; width: 319px;"><b>End Point</b> <i title="Click pencil, then click specific point in image to create crack end point.">(Click to end point on the image)</i></span>
        <mat-form-field style="width: 42%;">
          <input matInput type="text" [(ngModel)]="endXY" #end_="ngModel" [disabled]="true">
        </mat-form-field>
        <a (click)="ClearCurrentEndXY()" [ngClass]="isEndEdit ? 'selected-edit-point' : 'edit-point'"><i class="material-icons square-button__icon" style="cursor: pointer;" title="Click to end point">edit</i></a>
        <!--<a *ngIf="isEndEdit==false"><i class="material-icons square-button__icon" title="Confirm Ending Point">check_box</i></a>
        <a *ngIf="isEndEdit==true" (click)="ConfirmEndXY()"><i class="material-icons square-button__icon" title="Confirm Starting Point" style="cursor: pointer;">check_box_outline_blank</i></a>-->
      </div>
      <div *ngIf="TypeID==2" class="ttmodal__footer" style="margin-top: 0px; margin-bottom: 5px;">
        <div>
          <a class="button margin-right-8" style="width: 195px; text-align: center; "><span style="color: red; font-style: italic;" (click)="ClearAllXY()">Clear Crack Coordinates</span></a>
        </div>
      </div>

      <div class="ttmodal__footer" style="margin-top: 10px; margin-bottom: 5px; justify-content: left;">
        <div *ngIf="TypeID==2 && !_allowDelete" class="flex-row">
          <span class="left-span">Status</span>
          <mat-form-field style=" width: 100%;">
            <mat-select placeholder="Select Status" [(ngModel)]="crackStatusId" ngDefaultControl>
              <mat-option value="" disabled selected>Select Status</mat-option>
              <mat-option *ngFor="let cr of crackOptions" [value]="cr.Id">{{cr.CrackStatus}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-row-right" style="width: 100%;">
          <div>
            <button mat-raised-button (click)="onCloseClick()" [disabled]="loading" [class.loading]="loading">{{ "Cancel" | translate | async }}</button>
          </div>
          <div style="margin-left: 10px;">
            <button mat-raised-button color="warn" style=" width: 110px;" [disabled]="loading" [class.loading]="loading" (click)="saveObservation()">{{ (this.OPId == 0 ? "Save Point" : "Update Point") | translate | async }}</button>
          </div>
        </div>
      </div>



      <div class="flex-row" *ngIf="TypeID==1">
        <span *ngIf="TypeID==1" class="left-span">Use Range</span>
        <mat-checkbox *ngIf="TypeID==1" id="fecrNormal" [(ngModel)]="isFECRNormal" [checked]="isFECRNormal" color="primary"></mat-checkbox>
      </div>
      <div style="display: none; flex-direction: row;" *ngIf="TypeID==2">
        <span *ngIf="TypeID==2" class="left-span">Crack-Ignore Limits</span>
        <mat-checkbox *ngIf="TypeID==2" id="fecrCrack_" [(ngModel)]="isFECRCrack" [checked]="isFECRCrack"
                      style="" color="primary">
        </mat-checkbox>
      </div>

      <div class="flex-row" *ngIf="TypeID==1">
        <span class="left-span">No of Readings</span>
        <mat-form-field style="width: 30%; ">
          <input matInput type="number" min="0" max="5" step="1" [(ngModel)]="noOfReading"
                 (focusout)="checkMaxReading()" title="{{sToolTip_NoOfReadings}}" #noOfReading_="ngModel"
                 (keypress)="ValidateNumberInputs($event)">
        </mat-form-field>
      </div>

      <div class="flex-row" *ngIf="!isFECRCrack && (TypeID == 1 || TypeID == 2)">
        <span class="left-span">{{ TypeID == 1 ? 'Limit-New' : 'Enter Crack Length' }}</span>
        <mat-form-field style="width: 30%; ">
          <input matInput type="number"
                 [(ngModel)]="limitNew"
                 inputmode="decimal"
                 decimalLimit="2"
                 min="0"
                 (focusout)="checkPositive()" #limitNew_ (focus)="limitNew_.select()"
                 (ngModelChange)="copyValueTolimitWorn($event)">
          <span matSuffix>({{userUOM}})</span>
        </mat-form-field>
      </div>

      <div class="flex-row" *ngIf="!isFECRCrack && !isFECRNormal && (TypeID == 1 || TypeID == 2)">
        <span class="left-span">{{ TypeID == 1 ? 'Used Limit' : 'Max Crack Length' }}</span>
        <mat-form-field style="width: 30%; ">
          <input matInput type="number" inputmode="decimal" decimalLimit="2" min="0" [(ngModel)]="limitWorn" (focusout)="checkPositive()"
                 #limitWorn_ (focus)="limitWorn_.select()">
          <span matSuffix>({{userUOM}})</span>
        </mat-form-field>
      </div>

      <div class="flex-row" *ngIf="!isFECRCrack && isFECRNormal && TypeID == 1">
        <span class="left-span">Limit-Range</span>
        <mat-form-field style="width: 30%; ">
          <input matInput type="number" inputmode="decimal" decimalLimit="3" min="0" [(ngModel)]="limitRange" (focusout)="checkPositive()"
                 #limitRange_ (focus)="limitRange_.select()">
          <span matSuffix>({{userUOM}})</span>
        </mat-form-field>
      </div>

      <div class="flex-row" *ngIf="isFECRCrack">
        <span class="left-span">Measurement</span>
        <mat-form-field style="width: 30%; ">
          <input matInput type="number" inputmode="decimal" decimalLimit="2" min="0" [(ngModel)]="measurement" (focusout)="checkPositive()"
                 #measurement_ (focus)="measurement_.select()">
          <span matSuffix>({{userUOM}})</span>
        </mat-form-field>
      </div>


      <div class="flex-row" *ngIf="TypeID==2 && crackLocationlist?.length > 0">
        <span class="left-span">Crack Location</span>
        <mat-form-field style="width: 100%; ">
          <mat-select placeholder="Select Crack Location" (openedChange)="onOpened($event)" [(ngModel)]="crackLocationId" ngDefaultControl>
            <mat-option value="" disabled selected>Select Crack Location</mat-option>
            <mat-option *ngFor="let opt of crackLocationlist" [value]="opt.ID">{{opt.Name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex-row" *ngIf="TypeID==2 && showCrackLocation">
        <span class="left-span">Obs. Location</span>
        <mat-form-field style="width: 100%; ">
          <mat-select placeholder="Select Obs. Location" (openedChange)="onOpened($event)" [(ngModel)]="obsLocationId" ngDefaultControl>
            <mat-option value="" disabled selected>Select Obs. Location</mat-option>
            <mat-option *ngFor="let opt of obsList" [value]="opt.ID">{{opt.Name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex-row" *ngIf="TypeID==2 && showCrackSeverity">
        <span class="left-span">Crack Severity</span>
        <mat-form-field style="width: 100%; ">
          <mat-select placeholder="Select Crack Severity" (openedChange)="onOpened($event)" [(ngModel)]="crackSeverityId" ngDefaultControl>
            <mat-option value="" disabled selected>Select Crack Severity</mat-option>
            <mat-option *ngFor="let opt of severityList" [value]="opt.ID">{{opt.Name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex-row">
        <span class="left-span">Comments</span>
        <textarea [(ngModel)]="comments" rows="4" style="width:100%;"></textarea>
      </div>

      <div style="display: none; flex-direction: row;">
        <span class="left-span">Inspection Type</span>
        <mat-form-field style="width: 100%; ">
          <mat-select placeholder="Select Inspection Type" [(ngModel)]="InspectionTypeID" ngDefaultControl>
            <mat-option value="" disabled selected>Select Inspection Type</mat-option>
            <mat-option *ngFor="let opt of InspectionTypeList" [value]="opt.ID">{{opt.Name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="TypeID!=2" class="flex-row" style="margin-bottom: 10px;">
        <span class="left-span">Question</span>
        <mat-form-field style="width: 100%;">
          <input matInput class="qstyle" type="text" [(ngModel)]="Qname" #Qname_="ngModel" ngDefaultControl />
        </mat-form-field>
      </div>

      <div *ngIf="TypeID!=2" class="flex-row">
        <span class="left-span">Question Instructions</span>
        <textarea rows="3" style="width:100%;" [(ngModel)]="Qdesc"></textarea>
      </div>

      <input hidden type='file' (change)="onSelectOPQuestionImage($event)" #uploadImage>
      <div *ngIf="TypeID!=2" class="flex-row" style="margin-bottom: 15px; margin-top: 25px;">
        <span class="left-span">Question Image</span>
        <div (click)="uploadImage.click()" style="cursor: pointer;" [title]="OPQuestionImage ? 'Edit image' : 'Add image'">
          <i class="material-icons add-implement-image-icon">note_add</i>
          <img style="width:50px; height:50px" *ngIf="OPQuestionImage" [src]="getImage(OPQuestionImage)">
        </div>
      </div>

      <div class="flex-row" *ngIf="TypeID!=2">
        <span class="left-span">Need</span>
        <div>
          <mat-checkbox [checked]="checkedImage" (change)="ChangeIsImage(IsImage)" [(ngModel)]="IsImage"> Image</mat-checkbox>
        </div>
        <div style=" margin-left: 50px;">
          <mat-checkbox [checked]="checkedAnswe" (change)="ChangeIsAnswer(IsAnswer)" [(ngModel)]="IsAnswer"> Answer</mat-checkbox>
        </div>
      </div>

    </div>
    <div class="div-right-pan">
      <div *ngIf="schematic != null" style="width: auto; height: auto; position: relative;">
        <img #image [src]="getImage(schematic)" style="width:640px; height: 100%;" (click)="openObservationPointModal($event)" >
        <ng-container *ngIf="obsDetails != null">
          <ng-container *ngFor="let cp of obsDetails">
            <i class="material-icons button__icon component-dot" *ngIf="cp.observationPointTypeId != 2"
               [class.green-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'green'"
               [class.yellow-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'"
               [class.orange-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'orange'"
               [class.red-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'red'"
               [class.no-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'gray'"
               [class.default]="getEval(cp.WornPct, cp.InspectionDate) == 'magenta'"
               matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}} X,Y coord: {{cp.ObservationPointPosX}},{{cp.ObservationPointPosY}}"
               [ngStyle]="getPosition(cp.ObservationPointPosX, cp.ObservationPointPosY)">lens</i>

            <div *ngIf="cp.EndObservationPointPosY!=null && cp.EndObservationPointPosY !=0 "
                 [class.yellow-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'"
                 [class.crack-clickable]="canAdjustCrack(cp)"
                 [class.crack-not-clickable]="!canAdjustCrack(cp)"
                 (click)="adjustCrackStatus(cp)"
                 matTooltip="{{ getCrackTooltip(cp) }}"
                 [style]="getLine(cp.ObservationPointPosX, cp.ObservationPointPosY,cp.EndObservationPointPosX, cp.EndObservationPointPosY,cp.isCrackFixed, cp)"></div>

            <!--matTooltip="{{cp.ObservationPointName}} Crack Date - {{cp.InstallDate}} - Current Length {{cp.CurrentLength}} {{userUOM}} - Crack Status {{cp.CrackStatus}}
                   {{cp.CrackSeverity != null ? ' - Severity ' + cp.CrackSeverity : ''}} -  {{ cp.CrackStatusId === 1 ? '' : ' - (' + cp.WornPct + '% Worn)' }}"-->
          </ng-container>
        </ng-container>
      </div>
      <div class="crack-container">
        <h3>Crack Display Options</h3>
        <div class="crack-row" *ngFor="let option of crackOptions">
          <span *ngIf="option.ColorCode" class="crack-color" [style.backgroundColor]="option.ColorCode"></span>
          <input type="checkbox" [(ngModel)]="option.isSelected" (change)="onCrackChange(option)" class="crack-checkbox" />
          <span class="crack-label">{{ option.CrackStatus }}</span>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; justify-content: space-between; padding: 0 30px;">
        <div *ngFor="let image of _ObservationImages; let i = index"
             style="display: flex; flex-direction: column; margin: 10px;">
          <label style="text-align: center; font-weight: bold;">{{ i + 1 }}</label>

          <img *ngIf="image.ImageData || image.ImageDataPath"
               class="photo-container__photo"
               title="Change Image"
               [src]="sanitize(image)"
               style="width: 100px; cursor: pointer;"
               (click)="fileInputRefs[i].click()" />

          <span *ngIf="!image.ImageData && !image.ImageDataPath"
                style="font-size: 80px; cursor: pointer;"
                title="Add Image"
                class="material-icons"
                (click)="fileInputRefs[i].click()">
            wallpaper
          </span>

          <input type="file"
                 style="display: none;"
                 #fileInput
                 (change)="replacePhotoClicked($event, i)" />
        </div>

      </div>

    </div>

  </div>

  <div class="tt-footer">
    <div class="footer-left-pan">
      <div>
        <button mat-raised-button (click)="onCloseClick()" [disabled]="loading" [class.loading]="loading">{{ "Cancel" | translate | async }}</button>
      </div>
      <div style="margin-left: 10px;">
        <button mat-raised-button color="warn" [disabled]="loading || !_ObsPointSaved" [class.loading]="loading" (click)="saveObservationDetails(1)">{{ "Save Details" | translate | async }}</button>
      </div>
      <div style="margin-left: 10px;">
        <button mat-raised-button color="warn" [disabled]="loading || !_ObsPointSaved " [class.loading]="loading" (click)="saveObservationDetails(2)">{{ "Save & Close" | translate | async }}</button>
      </div>
    </div>
    <div class="footer-right-pan">
      <button mat-raised-button class="button-delete" [disabled]="!_allowDelete || (loading || !_ObsPointSaved)" [class.loading]="loading" (click)="openDeleteConfirmationBox()">{{ "Delete Obs. Point" | translate | async }}</button>
    </div>
  </div>

</div>


